<div class="modal-header">
  <h3 class="modal-title">
    {{ title }} <i (click)="cancel()" class="fa fa-times pull-right"></i>
    <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px" (click)="minimise = !minimise"></i>
  </h3>
</div>

<div class="modal-body" [hidden]="minimise">
  
  <!-- Entity Details (following established pattern) -->
  <!-- <div class="entityDetails" style="margin-left: 9px; margin-right: 30px">
    <table style="width: 100%;">
      <tbody>
        <tr>
          <td class="LayerLine1" nowrap>Entity:</td>
          <td class="LayerData1" nowrap>{{rowData.ENTITY_NAME + " : " + rowData.TAX_YEAR}}</td>
          <td class="LayerLine1" nowrap>Business:</td>
          <td class="LayerData1" nowrap>{{rowData.PARENT_ME_CODE + " - " + rowData.PARENT_ME}}</td>
          <td class="LayerLine1" nowrap>Tax Code:</td>
          <td class="LayerData1" nowrap>{{rowData.MARS}}</td>
        </tr>
      </tbody>
    </table>
  </div> -->

  <!-- Loading indicator -->
  @if (loading) {
<div class="loading-container">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
    <div class="loading-text">Loading form data...</div>
  </div>
}

  <!-- Main content -->
  @if (!loading) {
<div>
    
    <!-- Life Loss Push Carryover Override Section -->
    <div class="col-md-12">
      <h4 class="BlackSmHdrBC" style="font-weight: bold;">
        Life Loss Push Carryover Override
      </h4>
    </div>
    <hr>
    
    <!-- Headers -->
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-3 LayerData1">
        <label>Amount</label>
      </div>
      <div class="col-md-5 LayerData1">
        <label>Comments</label>
      </div>
    </div>

    <!-- System calculated values (readonly) -->
    <div class="row">
      <div class="col-md-3">
        <div class="centerText">
          <input readonly type="text" class="form-control input-sm numText" 
                 [value]="li_loss_carryover" placeholder="">
        </div>
      </div>
      <div class="col-md-5">
        <input readonly type="text" class="form-control" 
               [value]="li_lpc_comments" placeholder="">
      </div>
    </div>
    
    <hr style="height: 1px; border: none; color: #FFFFFF; background-color: #FFFFFF;">
    
    <!-- Life Insurance editable data -->
    @for (row of li_jsonData; track trackByFn($index, row)) {
<div>
      <div class="row">
        <div class="col-md-3 centerText">
          <div class="centerText">
            <input type="text" class="form-control input-sm numText"
                   [class.input-error]="row.AMOUNT === 0 || row.AMOUNT === undefined"
                   [(ngModel)]="row.AMOUNT" placeholder="">
          </div>
          @if (row.AMOUNT === 0 || row.AMOUNT === undefined) {
<div class="form-error-container">
            Please Enter Amount
          </div>
}
        </div>
        <div class="col-md-5 centerText">
          <div class="centerText">
            <input type="text" class="form-control"
                   [class.input-error]="row.COMMENTS === '' || row.COMMENTS === undefined"
                   [(ngModel)]="row.COMMENTS" placeholder="">
          </div>
          @if (row.COMMENTS === '' || row.COMMENTS === undefined) {
<div class="form-error-container">
            Please Add Comment
          </div>
}
        </div>
      </div>
      <hr style="height: 1px; border: none; color: #FFFFFF; background-color: #FFFFFF;">
    </div>
}

    <hr>
    
    <!-- Non-Life Loss Push Carryover Override Section -->
    <div class="col-md-12">
      <h4 class="BlackSmHdrBC" style="font-weight: bold;">
        Non-Life Loss Push Carryover Override
      </h4>
    </div>
    <hr>
    
    <!-- Headers -->
    <div class="row">
      <div class="col-md-1 LayerData1"></div>
      <div class="col-md-3 LayerData1">
        <label>Amount</label>
      </div>
      <div class="col-md-5 LayerData1">
        <label>Comments</label>
      </div>
    </div>

    <!-- System calculated values (readonly) -->
    <div class="row">
      <div class="col-md-3 centerText">
        <div class="centerText">
          <input readonly type="text" class="form-control input-sm numText" 
                 [value]="nl_loss_carryover" placeholder="">
        </div>
      </div>
      <div class="col-md-5">
        <input readonly type="text" class="form-control" 
               [value]="nl_lpc_comments" placeholder="">
      </div>
    </div>
    
    <hr style="height: 1px; border: none; color: #FFFFFF; background-color: #FFFFFF;">
    
    <!-- Non-Life editable data -->
    @for (row of nl_jsonData; track trackByFn($index, row)) {
<div>
      <div class="row">
        <div class="col-md-3 centerText">
          <div class="centerText">
            <input type="text" class="form-control input-sm numText"
                   [class.input-error]="row.AMOUNT === 0 || row.AMOUNT === undefined"
                   [(ngModel)]="row.AMOUNT" placeholder="">
          </div>
          @if (row.AMOUNT === 0 || row.AMOUNT === undefined) {
<div class="form-error-container">
            Please Enter Amount
          </div>
}
        </div>
        <div class="col-md-5 centerText">
          <div class="centerText">
            <input type="text" class="form-control"
                   [class.input-error]="row.COMMENTS === '' || row.COMMENTS === undefined"
                   [(ngModel)]="row.COMMENTS" placeholder="">
          </div>
          @if (row.COMMENTS === '' || row.COMMENTS === undefined) {
<div class="form-error-container">
            Please Add Comment
          </div>
}
        </div>
      </div>
      <hr style="height: 2px; border: none; color: #FFFFFF; background-color: #FFFFFF;">
    </div>
}

  </div>
}
</div>

<!-- Footer buttons -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button" (click)="save()" [disabled]="subconsole">
    @if (subconsole) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="btn btn-danger-outline btn-sm" type="button" (click)="reset()">Reset</button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>